var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleCardChassis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0h236464na)",
    fill: "#818B9B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.75 6.75H2.25A2.25 2.25 0 0 0 0 9v15a2.25 2.25 0 0 0 2.25 2.25h31.5A2.25 2.25 0 0 0 36 24V9a2.25 2.25 0 0 0-2.25-2.25zM34.5 24a.75.75 0 0 1-.75.75H2.25A.75.75 0 0 1 1.5 24V9a.75.75 0 0 1 .75-.75h31.5a.75.75 0 0 1 .75.75v15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5H6a2.25 2.25 0 0 0-2.25 2.25v3A2.25 2.25 0 0 0 6 18h1.5a2.25 2.25 0 0 0 2.25-2.25v-3A2.25 2.25 0 0 0 7.5 10.5zM6 12h1.5l-2.25 3v-2.25A.75.75 0 0 1 6 12zm1.5 4.5H6l2.25-3v2.25a.75.75 0 0 1-.75.75zM22.5 10.5H21a2.25 2.25 0 0 0-2.25 2.25v3A2.25 2.25 0 0 0 21 18h1.5a2.25 2.25 0 0 0 2.25-2.25v-3a2.25 2.25 0 0 0-2.25-2.25zM21 12h1.5l-2.25 3v-2.25A.75.75 0 0 1 21 12zm1.5 4.5H21l2.25-3v2.25a.75.75 0 0 1-.75.75zM13.5 15h2.25v2.25a.75.75 0 1 0 1.5 0v-6a.75.75 0 1 0-1.5 0v2.25H13.5a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 1 0-1.5 0v1.5A2.25 2.25 0 0 0 13.5 15zM31.5 12a.75.75 0 1 0 0-1.5h-3.75a1.5 1.5 0 0 0-1.5 1.5v1.5a1.5 1.5 0 0 0 1.5 1.5h3v1.5H27a.75.75 0 1 0 0 1.5h3.75a1.5 1.5 0 0 0 1.5-1.5V15a1.5 1.5 0 0 0-1.5-1.5h-3V12h3.75zM19.5 21h-3a.75.75 0 1 0 0 1.5h3a.75.75 0 1 0 0-1.5zM12.968 20.468l-.218.225-.217-.225a.753.753 0 0 0-1.065 1.065l.225.217-.225.218a.753.753 0 0 0 1.065 1.065l.217-.225.218.225a.753.753 0 1 0 1.065-1.065l-.225-.218.225-.217a.753.753 0 1 0-1.065-1.065zM23.468 20.468l-.218.225-.217-.225a.752.752 0 1 0-1.065 1.065l.225.217-.225.218a.753.753 0 0 0 1.065 1.065l.217-.225.218.225a.753.753 0 1 0 1.065-1.065l-.225-.218.225-.217a.753.753 0 1 0-1.065-1.065z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "0h236464na"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleCardChassis);
export default __webpack_public_path__ + "static/media/vehicle-card-chassis.a0466284178b0edfc617da005bd81d73.svg";
export { ForwardRef as ReactComponent };